import { render, staticRenderFns } from "./CentresInterets.vue?vue&type=template&id=82275acc&"
import script from "./CentresInterets.vue?vue&type=script&lang=js&"
export * from "./CentresInterets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports